import styled from '@emotion/styled';
import { Select, Typography } from '@innovamat/glimmer-components';
import type { Classroom } from '@innovamat/glow-api-client';
import { dates } from '@innovamat/radiance-utils';
import { useTranslation } from 'react-i18next';
import { DigitalPracticeAnnouncement } from '../../../digital-practice-announcement/components/digital-practice-announcement';

const Description = styled(Typography.Body2)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
  width: 100%;
  > * {
    width: 100%;
  }
`;

const SelectWrapper = styled.div`
  width: 50%;
`;

type Props = {
  classroom?: Classroom;
  isEditing?: boolean;
  digitalPracticeFirstDayOfWeek: string;
  digitalPracticeFirstHourOfWeek: string;
  onChange: (value: string) => void;
};

function DigitalPracticeSection({
  classroom,
  isEditing,
  digitalPracticeFirstDayOfWeek,
  digitalPracticeFirstHourOfWeek,
  onChange,
}: Props): JSX.Element {
  const { t } = useTranslation();

  const daysOfWeek = dates.getDaysOfWeek(t);

  return (
    <>
      <Typography.Subtitle2>
        {t('reports.startPractice.text')}
      </Typography.Subtitle2>
      <Description>
        {t('digitalPractice.modifyDigitalPracticeModal.description')}
      </Description>
      <Content>
        <SelectWrapper>
          <Select
            dataTestId="digital-practice-section-day-selector"
            labelText={t(
              'digitalPractice.modifyDigitalPracticeModal.firstDayOfWeek'
            )}
            maxHeight={200}
            menuPortalTarget={document.body}
            options={daysOfWeek}
            placeholder={t('classroom.input.placeholder.selectDay')}
            value={digitalPracticeFirstDayOfWeek}
            onChange={(day) => day?.value && onChange(day.value)}
          />
        </SelectWrapper>
        {isEditing && (
          <DigitalPracticeAnnouncement
            classroom={classroom}
            digitalPracticeFirstDayOfWeek={digitalPracticeFirstDayOfWeek}
            digitalPracticeFirstHourOfWeek={digitalPracticeFirstHourOfWeek}
          />
        )}
      </Content>
    </>
  );
}

export { DigitalPracticeSection };
